import Block from "@components/block"
import stageTitleImg from "@imagesgz/title-stage.png"
import stageTitleAppImg from "@imagesgz/title-stage-app.png"
import Box from "@src/components/box"
import ResponsiveComing from "@src/components/responsiveContent/coming"
import Title from "@src/components/title"
import React from "react"
import classnames from "@src/utils/classnames"
import * as styles from "./stage.module.scss"

const Stage = () => {
  return (
    <Block id="stage" title={[stageTitleImg, stageTitleAppImg]}>
      <Box>
        <Title sub="Main Stage">核聚变主舞台</Title>
        <ResponsiveComing />
      </Box>
      <Box>
        <Title sub="Speedrun Stage">核聚变速通舞台</Title>
        <ResponsiveComing />
      </Box>
    </Block>
  )
}

export default Stage
